import axios from "axios"
import { IsEmptyString } from "../Components/GeneralFunctions"

const cLookupBaseApi = "https://lookup-va.cloudcti.nl/lookup/api/"

export async function LookupApiGetSearchHistory(aSecurityToken) 
{
    try 
    {
      const result = await axios.get(
        cLookupBaseApi + "userdata/searchhistory",
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json"
            }
        })
      return result.data
    } 
    catch (ex)
    { 
        return "" 
    }
}

export async function LookupApiUpdateSearchHistory(aSecurityToken, aSearchHistory) 
{
    try 
    {
      await axios.put(cLookupBaseApi + "userdata/searchhistory",
        aSearchHistory,
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        })
    } 
    catch (ex) 
    { 
        console.log("Failed to update SpeedDials: " + ex)
    }
}

export async function LookupApiGetSpeedDials(aSecurityToken) 
{
    try 
    {
      const result = await axios.get(
        cLookupBaseApi + "userdata/speeddials",
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json"
            }
        })
      return result.data
    } 
    catch (ex)
    { 
        return "" 
    }
}

export async function LookupApiUpdateSpeedDials(aSecurityToken, aSpeedDials) 
{
    try 
    {
      await axios.put(cLookupBaseApi + "userdata/speeddials",
        aSpeedDials,
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        })
    } 
    catch (ex) 
    { 
        console.log("Failed to update SpeedDials: " + ex)
    }
}

export async function LookupApiLookupNumber(aSecurityToken, aNumber, aCallId, aCallRecordingId) 
{
    const IntegrationOrderString = localStorage.getItem("integrationorder")
    const Url = cLookupBaseApi + "lookupnumber?number=" + aNumber + "&starttime=" + encodeURIComponent(new Date().toLocaleString()) + 
        (!IsEmptyString(aCallId) ? "&callid=" + aCallId : "") +
        (!IsEmptyString(aCallRecordingId) ? "&callrecordingid=" + aCallRecordingId : "") +
        (!IsEmptyString(IntegrationOrderString) ? "&integrationorder=" + IntegrationOrderString : "")
    console.log("LookupApiLookupNumber",Url)

    const result = await axios.get(Url,  
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json"
            }
        })

    //Update the scripts to use the webpage instead of the screenpopurl if it is there
    if ((result.data.Matches !== null) && (result.data.Matches !== undefined) && (result.data.Matches.length > 0))
    {
        result.data.Matches.map((match) => 
        {
            if ((match.Scripts !== null) && (match.Scripts !== undefined) && (match.Scripts.length > 0))
            {
                match.Scripts.map((script) => 
                {
                    if (!IsEmptyString(script.Settings.WebPage))
                    {
                        script.ScreenpopUrl = script.Settings.WebPage
                    }
                })
            }
        })
    }

    return result
}

export async function LookupApiLookupMultipleNumbers(aSecurityToken, aNumbers) 
{
    const result = await axios.post(cLookupBaseApi + "lookupmultiplenumbers", 
        {
            "Numbers": aNumbers
        }, 
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json"
            }
        })
    return result
}

export function LookupApiClientReplicatorInfo(aSecurityToken) 
{
    return axios.get(cLookupBaseApi + "clientreplicatorinfo",  
    {
        headers: {
            Authorization: "Bearer " + aSecurityToken,
            Accept: "application/json"
        }
    })
}

export async function LookupApiSearchName(aSecurityToken, aName) 
{
    const IntegrationOrderString = localStorage.getItem("integrationorder")
    const result = await axios.get(cLookupBaseApi + "searchname?name=" + aName + "&maxresults=10" + 
        (!IsEmptyString(IntegrationOrderString) ? "&integrationorder=" + IntegrationOrderString : ""),  
    {
        headers: {
            Authorization: "Bearer " + aSecurityToken,
            Accept: "application/json"
        }
    })
    return result.data
}